module.exports = __webpack_public_path__ + "static/media/loading.f30e8231.svg";


//////////////////
// WEBPACK FOOTER
// ./src/arteia-js/components/Loading/loading.svg
// module id = 159
// module chunks = 0